/**
 * NextEpisodeFillContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import { TRANSITION } from '@shared/types/constants/animations';

/**
 * Styled next episode fill container.
 */
const NextEpisodeFillContainer = styled.div<Props>`
  background: ${(props) =>
    props.focused ? Colors['progress']['fillNextEpisode'] : 'none'};
  bottom: ${60 * Screen.widthRatio}px;
  height: 100%;
  position: relative;
  transition: ${TRANSITION.NEXT_EPISODE_FILL};
  width: ${(props) => props.fill || 0}%;
  z-index: -1;
`;

export default NextEpisodeFillContainer;
